/*
 * @Description  : 场地门禁记录
 * @Author       : zcc
 * @Date         : 2025-04-09 16:13:31
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-11 10:05:57
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\site-entrance-records.js
 */
import request from "../request.js";

// 门禁记录-分页列表 ---- 沈洋
export const getMeetingDoorRecordPage = function (data) {
	return request({
		url: "bmMeeting/getMeetingDoorRecordPage",
		method: "post",
		data
	});
};